export default __webpack_public_path__ + "static/FBI-Logo-2d4284aefafb120a2c34f7bac0f7a67b.jpg";